var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./SustainableEventBannerLarge.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = function insertWithDynamicNonce(style) {
                style.setAttribute('nonce', window.env.nonce)
                document.head.appendChild(style)
              };
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};